import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';
import { useCallback, useEffect, useState } from 'react';
import { getModule } from '@jwp/ott-common/src/modules/container';
import { useAccountStore } from '@jwp/ott-common/src/stores/AccountStore';
import AccountController from '@jwp/ott-common/src/controllers/AccountController';

import Button from '../Button/Button';
import FormFeedback from '../FormFeedback/FormFeedback';
import { modalURLFromLocation } from '../../utils/location';
import LoadingOverlay from '../LoadingOverlay/LoadingOverlay';

import styles from './SsoErrorComponent.module.scss';

type Props = {
  isTokenError: boolean;
};
const SsoErrorComponent = ({ isTokenError }: Props) => {
  const accountController = getModule(AccountController);

  const { t } = useTranslation(['user', 'common']);

  const [errorMessage, setErrorMessage] = useState<string>();

  const navigate = useNavigate();
  const location = useLocation();

  const handleCancel = useCallback(() => {
    navigate('/');
  }, [location, navigate]);

  // useEffect(() => {
  //   const error = location?.state?.error;
  //   console.log('error model', error.message);
  // }, []);

  useEffect(() => {
    const error = location?.state?.error;
    if (error?.message) {
      setErrorMessage(error.message);
    } else {
      setErrorMessage(t('user:profile.default_error_message'));
    }
  }, []);

  return (
    <div className={styles.formContainer}>
      {isTokenError ? (
        <>
          <h2 className={styles.heading}>{t('user:profile.invalid_token')}</h2>
          <p className={styles.paragraph}>{t('user:profile.invalid_token_content')}</p>
        </>
      ) : (
        <>
          <h2 className={styles.heading}>{t('user:profile.login_error')}</h2>
          <p className={styles.paragraph}>{errorMessage}</p>
        </>
      )}
      <div className={styles.passwordButtonsContainer}>
        <Button type="submit" onClick={handleCancel} className={styles.button} color="primary" fullWidth label={t('common:alert.close')} />
      </div>
    </div>
  );
};

export default SsoErrorComponent;
